import { ERRORS } from "../../../../../constants/errors";
import { caseInsensitiveRegex } from "./regex";
import type { Validator } from "./types";

export const email: Validator = ({ name, answer, questionErrorMessage }) => {
  // This regex is a direct replica of the Ruby version
  // used in Chopin for backend validation.
  // https://github.com/simplybusiness/chopin/blob/master/app/assets/javascripts/ci5/smart_form.js#L2323
  const expression =
    "^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@(?!xn--)[a-z0-9](?:[a-z0-9_-]{0,61}[a-z0-9])?(?:\\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])){1,}$";

  return caseInsensitiveRegex({
    name,
    answer,
    validation: {
      type: "regex",
      value: expression,
    },
    questionErrorMessage,
    fallbackMessage: ERRORS.INVALID_EMAIL,
  });
};
